import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-02546d6e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "m-list-wrap" }
const _hoisted_2 = ["src", "onClick"]
const _hoisted_3 = { style: {"height":"4rem","padding":"1rem"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_before_upload = _resolveComponent("before-upload")!
  const _component_note_progress = _resolveComponent("note-progress")!
  const _component_comments_res = _resolveComponent("comments-res")!
  const _component_aio_confirm = _resolveComponent("aio-confirm")!
  const _component_van_action_sheet = _resolveComponent("van-action-sheet")!
  const _component_upload_progress = _resolveComponent("upload-progress")!
  const _component_note_strategy = _resolveComponent("note-strategy")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_before_upload, { onCallUploadAction: $setup.callUploadAction }, null, 8, ["onCallUploadAction"]),
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.noteList, (item, index) => {
        return (_openBlock(), _createElementBlock("img", {
          src: `${item.resource.indexOf('http') === 0 ? '' : 'data:image/gif;base64,'}${item.resource}`,
          alt: "",
          key: `img-${index}`,
          class: "u-img-tile",
          onClick: ($event: any) => ($setup.handlePreview(index))
        }, null, 8, _hoisted_2))
      }), 128))
    ]),
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.showStrategy && $setup.showStrategy(...args)))
    }, "笔记策略" + _toDisplayString($setup.strategyFirstShow), 1),
    _createElementVNode("div", {
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.showDelNoteConfirm && $setup.showDelNoteConfirm(...args)))
    }, "删除笔记"),
    _createElementVNode("div", {
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.uploadResources && $setup.uploadResources(...args)))
    }, "上传文件"),
    _createElementVNode("div", {
      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.showProgressUpload && $setup.showProgressUpload(...args)))
    }, "上传文件1"),
    _createVNode(_component_note_progress, {
      status: false,
      progressList: $setup.progressList
    }, null, 8, ["progressList"]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_comments_res)
    ]),
    _createVNode(_component_aio_confirm, {
      visible: $setup.delNoteConfirmVisible,
      confirmInfo: $setup.delConfirmInfo
    }, null, 8, ["visible", "confirmInfo"]),
    _createVNode(_component_van_action_sheet, {
      show: $setup.callUploadActionVisible,
      "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => (($setup.callUploadActionVisible) = $event)),
      onSelect: $setup.handleSelectUploadAction,
      actions: $setup.callUploadActions,
      "cancel-text": "取消",
      "lock-scroll": "",
      "close-on-click-action": true
    }, null, 8, ["show", "onSelect", "actions"]),
    _createVNode(_component_upload_progress, {
      total: $setup.total,
      doneNum: $setup.doneNum,
      visible: $setup.uploadProgressVisible,
      onCancelUpload: $setup.cancelUpload
    }, null, 8, ["total", "doneNum", "visible", "onCancelUpload"]),
    _createVNode(_component_van_action_sheet, {
      show: $setup.strategyVisible,
      "onUpdate:show": _cache[5] || (_cache[5] = ($event: any) => (($setup.strategyVisible) = $event)),
      title: "笔记攻略",
      closeable: "",
      class: "startegy-action-sheet"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_note_strategy, {
          firstShow: $setup.strategyFirstShow,
          style: {"height":"'40%'"},
          onCallUploadAction: $setup.callUploadAction
        }, null, 8, ["firstShow", "onCallUploadAction"])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}